import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'VOICE': {
      'ENABLE': 'Habilitar pistas de audio a la encuesta',
      'TITULO': 'Configuración de voces',
      'SUBTITULO': 'Esta configuración sólo será aplicada si están habilitadas las pistas de audio a la encuesta',
      'CONFIG_IDIOMA': {
        'TITULO': 'Configuración actual para este idioma',
        'GENERO': {
          'TITULO': 'Genero de voz',
          'Femenino': 'Femenino',
          'Masculino': 'Masculino'
        },
        'TIPO_VOZ': {
          'TITULO': 'Tipo de voz',
          '1': 'Tipo de voz 1',
          '2': 'Tipo de voz 2',
          '3': 'Tipo de voz 3',
          '4': 'Tipo de voz 4',
          '5': 'Tipo de voz 5',
          '6': 'Tipo de voz 6',
          '7': 'Tipo de voz 7',
          '8': 'Tipo de voz 8',
          '9': 'Tipo de voz 9',
          '10': 'Tipo de voz 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Prueba de voz',
          'INSTRUCCION': 'Escriba un texto para probar la voz',
          'PLACEHOLDER': 'Texto de prueba de voz',
          'PROBAR': 'Probar texto a voz'
        }
      },
      'MODALES': {
        'COMPLETAR': '¿Está seguro de completar el paso con la selección de voces actual?',
        'COMPLETAR_OFF': '¿Está seguro de completar el paso con la configuración de voz deshabilitada?',
        'INCOMPLETO': 'Aún no ha realizado la selección completa de voces en todos los idiomas, es necesario que la complete para continuar',
        'PASO_COMPLETO': 'El paso se completó correctamente',
        'GENERANDO_AUDIOS': 'Se está aplicando la configuración de voces a las secciones de este producto, espere un momento'
      }
    }
  }
};
